/* eslint-disable no-unused-vars */
import React, { useEffect, useContext, useState } from 'react'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

import { StyleSheet, css } from 'aphrodite'
import { COLOR_BLACK, COLOR_WHITE } from '../../lib/colors'
import LiveContext from '../../components/Context/LiveContext'
import Video from 'twilio-video'
import { VideoChat } from '../../components/TwilioVideo/VideoChat'

import LivePending from './LivePending'
import api from '../../api'

const LivePreview = () => {
  const { t } = useTranslation('translation')

  const [room, setRoom] = useState(null)

  const toastId = React.useRef(null)

  const {
    isLivePreviewOpened,
    isLivePreviewMinimized,
    toggleLivePreview,
    setLocalDataTrack,
  } = useContext(LiveContext)

  useEffect(() => {
    if (isLivePreviewOpened && !isLivePreviewMinimized) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'scroll'
    }
  }, [isLivePreviewOpened, isLivePreviewMinimized])

  useEffect(() => {
    return () => {
      if (room) {
        room.localParticipant.audioTracks.forEach((publication) => {
          publication.unpublish()
          publication.track.stop()
        })
      }
    }
  }, [])

  useEffect(() => {
    if (!isLivePreviewOpened) return
    const idRequest = localStorage.getItem('idRequest')
    ;(async () => {
      if (navigator.mediaDevices !== undefined) {
        toastId.current = toast.info(t('common.permissionRequest'), {
          autoClose: false,
        })

        navigator.mediaDevices
          .getUserMedia({
            audio: true,
            video: false,
          })
          .then(async (stream) => {
            toast.dismiss(toastId.current)
            const localTracks = await Video.createLocalTracks({
              video: false,
              audio: true,
            })
            const localDataTrack = new Video.LocalDataTrack()
            localTracks.forEach((stream) => {
              if (stream.kind === 'video') {
                stream.stop()
              }
            })
            setLocalDataTrack(localDataTrack)
            api
              .get(`/requests/${idRequest}/room`)
              .then((room) => {
                Video.connect(room?.token, {
                  name: idRequest,
                  tracks: [...localTracks, localDataTrack],
                })
                  .then((room) => {
                    setRoom(room)
                  })
                  .catch((err) => {
                    console.error(err)
                  })
              })
              .catch((e) => {
                toast.error(t('pages.livePreview.roomError'))
                toggleLivePreview(false)
              })
          })
          .catch((error) => {
            toast.dismiss(toastId.current)
            toast.info(t('common.permissionRequest'), {
              autoClose: false,
            })
            toggleLivePreview(false)
          })
      } else {
        toast.error(t('pages.livePreview.roomError'))
        toggleLivePreview(false)
      }
    })()
  }, [isLivePreviewOpened])

  return (
    <>
      {isLivePreviewOpened && (
        <div
          className={css(
            styles.container,
            isLivePreviewMinimized && styles.containerMinimize
          )}
        >
          {room ? <VideoChat room={room} setRoom={setRoom} /> : <LivePending />}
        </div>
      )}
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    color: COLOR_BLACK,
    transition: 'all 1s ease',
    position: 'fixed',
    zIndex: '999',
    fontWeight: 700,
    letterSpacing: '-0.05em',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
  },
  containerMinimize: {
    transformOrigin: 'right bottom',
    transform: 'scale(0.3)',
    borderRadius: '20px',
    right: '20px',
    bottom: '20px',
    transition: 'all 1s ease',
  },
})

export default LivePreview
